/**
 * AuthorBio Component
 * Displays author information with expertise badges
 * Enhances E-A-T (Expertise, Authoritativeness, Trustworthiness) signals
 */

import { AUTHORS } from '@/libs/seo/constants';

export function AuthorBio({ authorName }) {
  const author = AUTHORS[authorName];

  if (!author) return null;

  return (
    <div className="author-bio border-l-4 border-blue-500 bg-gray-50 p-4 my-6">
      <div className="flex items-start gap-4">
        {author.image && (
          <img
            src={author.image}
            alt={author.name}
            className="w-16 h-16 rounded-full"
          />
        )}
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900">{author.name}</h3>
          {author.jobTitle && (
            <p className="text-sm text-gray-600">{author.jobTitle}</p>
          )}
          {author.description && (
            <p className="text-sm text-gray-700 mt-2">{author.description}</p>
          )}
          {author.knowsAbout && author.knowsAbout.length > 0 && (
            <div className="mt-3">
              <p className="text-xs text-gray-600 mb-2">Expertise:</p>
              <div className="flex flex-wrap gap-2">
                {author.knowsAbout.map((expertise, index) => (
                  <span
                    key={index}
                    className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded"
                  >
                    {expertise}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
